import { CircularProgress } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";

const useStylesForSpinner = makeStyles((theme) => ({
  root: {
    position: "relative",
    color: "red",
  },

  top: {
    color: "#1a90ff",
    animationDuration: "550ms",
    left: 0,
  },
  circle: {
    strokeLinecap: "round",
    background: "red",
    color: "#231F20",
  },
}));

export const UiBackdropLoader = (props) => {
  const classes = useStylesForSpinner();

  const size = props.loaderSize ?? 40;
  const thickness = props.loaderThickness ?? 3;

  return (
    <>
      <div className="df-backdrop-loader" data-testid={props["data-testid"]}>
        {props.inverted ? (
          <div className="df-inverted">
            <CircularProgress
              variant="indeterminate"
              className={classes.top}
              classes={{
                circle: classes.circle,
              }}
              size={size}
              thickness={thickness}
            />
            {props.backdropMessage && (
              <p className="df-backdrop-loader__message">
                {props.backdropMessage}
              </p>
            )}
          </div>
        ) : (
          <CircularProgress
            variant="indeterminate"
            className={classes.top}
            classes={{
              circle: classes.circle,
            }}
            size={size}
            thickness={thickness}
          />
        )}
      </div>
    </>
  );
};

export const UiGrayBgLoader = (props) => {
  const classes = useStylesForSpinner();
  const bgLoaderClass = `df-whitecard-loader ${props.className || ""}`;

  const size = props.loaderSize ?? 40;
  const thickness = props.loaderThickness ?? 3;

  return (
    <>
      <div className={bgLoaderClass} data-testid={props["data-testid"]}>
        {props.inverted ? (
          <div className="df-inverted">
            <CircularProgress
              variant="indeterminate"
              className={classes.top}
              classes={{
                circle: classes.circle,
              }}
              size={size}
              thickness={thickness}
            />
          </div>
        ) : (
          <CircularProgress
            variant="indeterminate"
            className={classes.top}
            classes={{
              circle: classes.circle,
            }}
            size={size}
            thickness={thickness}
          />
        )}
      </div>
    </>
  );
};

export const UiGrayBgLoaderWithMessage = (props) => {
  const bgLoaderwithMsgClass = `df-whitecard-loader ${
    props.className && props.className
  }`;

  return (
    <>
      <div className={bgLoaderwithMsgClass}>
        <div className="df-wc-message">
          {props.icon}
          <p>{props.errorMessage}</p>
        </div>
      </div>
    </>
  );
};
